/**
 * @generated SignedSource<<af199aa4931f8369dbd0cb1a1c3f2681>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ReleaseReportLockInput = {
  reportId?: string | null;
  token?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type ReleaseReportLockMutation$variables = {
  input: ReleaseReportLockInput;
};
export type ReleaseReportLockMutation$data = {
  readonly releaseReportLock: {
    readonly released: boolean | null;
  } | null;
};
export type ReleaseReportLockMutation = {
  variables: ReleaseReportLockMutation$variables;
  response: ReleaseReportLockMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ReleaseReportLockPayload",
    "kind": "LinkedField",
    "name": "releaseReportLock",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "released",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ReleaseReportLockMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ReleaseReportLockMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "8544997d366348b3f75ae1fb9f5c3058",
    "id": null,
    "metadata": {},
    "name": "ReleaseReportLockMutation",
    "operationKind": "mutation",
    "text": "mutation ReleaseReportLockMutation(\n  $input: ReleaseReportLockInput!\n) {\n  releaseReportLock(input: $input) {\n    released\n  }\n}\n"
  }
};
})();

(node as any).hash = "094cb4454084cda1bf903a6ef469b138";

export default node;
